import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
//import { updateProductQuantity, removeProductFromCart, setDeliveryMethod, finalizePurchase } from '../redux/reducers/cartSlice';
import { Button, Row, Col, Form, Image, ProgressBar, Container, Alert } from 'react-bootstrap';
import MenuPrincipal from '../components/menuPrincipal';
import { useNavigate } from 'react-router-dom';
import '../style/checkout.css'
import { QrCodePix } from "qrcode-pix";
import iconePix from "../../src/assets/imagens/icons8-pix-100.png";
import api from '../redux/actions/configApi';
import Rodape from "../components/rodape";
import { emailConfirmacaoVenda } from '../redux/reducers/vendasSlice'; // Importa o thunk
//import { use } from 'react';
const Checkout = () => {

    const [qrCode, setQrCode] = useState('');
    const [end, setEnd] = useState('');
    const [horario, setHorario] = useState([]);
    const [rawPix, setRawPix] = useState('');
    const [currentStep, setCurrentStep] = useState(1);
    const [timeLeft, setTimeLeft] = useState(300); // 5 minutos para pagamento via Pix (300 segundos)
    const [isPaymentProcessing, setIsPaymentProcessing] = useState(false); // Controle de repetição de pagamento
    const { products, totalAmount, deliveryMethod } = useSelector((state) => state.cart);
    const [errorMessage, setErrorMessage] = useState(''); // Estado para mensagens de erro
    const navigate = useNavigate();
    const dispatch = useDispatch();

    // Gerencia o avanço de cada etapa
    const handleNextStep = async () => {
        if (currentStep === 2) {
            await savePaymentData();
        } else {
            setCurrentStep(currentStep + 1);
        }
    };
    const handlePreviousStep = () => {
        if (currentStep > 1) setCurrentStep(currentStep - 1);
    };

    // Temporizador para o pagamento via Pix
    useEffect(() => {
        if (currentStep === 2 && timeLeft > 0) {
            const timer = setInterval(() => setTimeLeft(prevTime => prevTime - 1), 1000);
            return () => clearInterval(timer);
        }
    }, [currentStep, timeLeft]);

    useEffect(() => {
        if (timeLeft === 0) {
            setTimeLeft(300); // Resetar o timer se o tempo acabar
        }
    }, [timeLeft]);

    // Formata o tempo restante no cronômetro
    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
    };
    // Função para calcular o CRC16
    useEffect(() => {
        async function generateDynamicPix() {
            const qrCodePix = QrCodePix({
                version: '01',
                key: 'contato@pentalobe.com.br',
                name: 'Pentalobe',
                city: 'Blumenau SC',
                transactionId: '1213221',
                // message: 'Recebidos da semana??? 😂',
                value: totalAmount,
            })

            const rawPixStr = qrCodePix.payload()
            const qrCodeBase64 = await qrCodePix.base64()

            setRawPix(rawPixStr)
            setQrCode(qrCodeBase64)
        }

        void generateDynamicPix();
    }, [totalAmount])

    useEffect(() => {
        const enderecoSalvo = localStorage.getItem('endereco');
        if (enderecoSalvo) {
            const enderecoObj = JSON.parse(enderecoSalvo);
            setEnd(enderecoObj);
            console.log('Endereço armazenado:', enderecoObj);
        }
        const horario = localStorage.getItem('horarios');
        if (enderecoSalvo) {
            const horarioObj = JSON.parse(horario);
            setHorario(horarioObj);
            console.log('Horario armazenado:', horarioObj);
        }

    }, [totalAmount])

    const savePaymentData = async () => {
        if (!isPaymentProcessing) {
            setIsPaymentProcessing(true); // Bloqueia novas tentativas de pagamento
            try {
                const response = await api.post('orders', {
                    products,
                    totalAmount,
                    payment_method: 'Pix',
                    deliveryMethod: 'Retirada na Loja'
                    // rawPix
                });
                console.log(response.data.order_code, 'response')
                let order_code = response.data.order_code;
                if (response.data.success) {
                    dispatch(emailConfirmacaoVenda(order_code));
                    setCurrentStep(3); // Avança para o próximo passo de conclusão da compra
                } else {
                    console.error('Erro na confirmação do pagamento:', response.data.message);
                }
            } catch (error) {
                console.log(error, 'error')
                if (error.response.data.codigo == 401) {
                    navigate('/checkout');
                } else {
                    setErrorMessage("Falha ao processar o pagamento. Por favor, tente mais tarde!.");
                }
                console.error('Erro no envio do pagamento:', error);
            } finally {
                setIsPaymentProcessing(false); // Desbloqueia o botão após o envio
            }
        }
    };

    return (
        <div>
            <MenuPrincipal />
            <div className='section-spacing-4'>
                <Row>
                    <Col xs={12} md={12} lg={12} className='progress-bar-2'>
                        <ProgressBar style={{ width: '30%' }} now={(currentStep / 3) * 100} label={`Passo ${currentStep} de 3`} className="custom-progress-bar mb-4" />
                    </Col>
                </Row>
                {/* Conteúdo por etapa */}
                <div className="checkout-container">
                    {currentStep === 1 && (
                        <div className="checkout-container">
                            <h2 className="step-title"><i style={{ color: '#E79800' }} class="fa-regular fa-rectangle-list"></i> Resumo da Compra</h2>
                            <Row>
                                {/* Coluna do resumo dos itens */}
                                <Col xs={12} md={6}>
                                    <div className="store-info">
                                        <h4 className="section-title-2">
                                            <i className="fas fa-shopping-cart icon"></i> Resumo dos Itens
                                        </h4>
                                        {products.map((item) => (
                                            <div key={item.id} className="cart-item">
                                                <div className="item-details">
                                                    <p><strong>Produto:</strong> {item.name}</p>
                                                    <p><strong>Preço Unitário:</strong> {item.price.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
                                                    <p><strong>Quantidade:</strong> {item.quantity}</p>
                                                    <strong>Total:</strong> {(item.price * item.quantity).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                                </div>
                                            </div>
                                        ))}
                                        <div className="order-total">
                                            <p><i className="fas fa-money-bill-wave icon"></i> <strong>Valor Total:</strong> {totalAmount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
                                        </div>
                                    </div>
                                </Col>
                                {/* Coluna do endereço da loja */}
                                <Col xs={12} md={6}>
                                    <div className="store-info">
                                        <h4 className="section-title-2">
                                            <i className="fas fa-store icon"></i> Local de Retirada
                                        </h4>
                                        <div className="store-address">
                                            <p ><strong>Endereço:</strong> {end}</p>
                                            {/*<p><strong>Telefone:</strong> (11) 1234-5678</p>*/}
                                            <p ><strong>Horário de Atendimento:</strong>
                                            </p>
                                            {horario?.map((horario, index) => (
                                                <p key={index}>{horario}</p>
                                            ))}
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    )}
                    {currentStep === 2 && (
                        <div className="checkout-step">
                            <h2 className="step-title"><i style={{ color: '#E79800' }} class="fa-regular fa-rectangle-list"></i> Forma de Pagamento</h2>
                            {errorMessage && (
                                <Alert className='text-center' variant="danger" onClose={() => setErrorMessage('')} dismissible>
                                    {errorMessage}
                                </Alert>
                            )}
                            <div className='checkout-step-box'>
                                <h4><img className='icone-pix' src={iconePix} /> Pix</h4>
                                <div className="pix-info">
                                    <p>Escaneie o QR Code ou copie o código Pix para pagamento:</p>
                                    <img src={qrCode} alt={'QR Code PIX'} />
                                    <p style={{ fontSize: '18px' }}><strong>Valor:</strong> <span style={{ color: '#4CAF50' }}><strong>{totalAmount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</strong></span></p>
                                    <p
                                        style={{
                                            maxWidth: '480px',
                                            margin: '0 auto',
                                            whiteSpace: 'nowrap',
                                            overflow: 'auto'
                                        }}
                                    >
                                        {rawPix}
                                    </p>

                                </div>
                            </div>
                        </div>
                    )}
                    {currentStep === 3 && (
                        <div className="checkout-step">
                            <h2 className="step-title"><i style={{ color: '#E79800' }} class="fa-solid fa-check"></i> Conclusão da Compra</h2>
                            <div className='checkout-step-box text-conclusao'>
                                <p>Obrigado pela sua compra! A confirmação será enviada ao seu e-mail.</p>
                                <p>Detalhes adicionais de retirada e pagamento.</p>
                            </div>
                        </div>
                    )}
                    {/* Botões de navegação */}
                    <Row>
                    </Row>
                    <div className='d-flex justify-content-center'>
                        <div className="checkout-navigation mt-4">
                            {currentStep > 1 && (
                                <Button onClick={handlePreviousStep} className="me-2">
                                    Voltar
                                </Button>
                            )}
                            {currentStep < 3 ? (
                                <Button onClick={handleNextStep}>
                                    Próximo
                                </Button>
                            ) : (
                                <a href='/dashboard'>
                                    <Button >
                                        Ir para o Painel
                                    </Button>

                                </a>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <Rodape />
        </div>
    );
};

export default Checkout;
